import { Box, Typography } from "@mui/material"
import { format, parseISO } from "date-fns"
import { SmallLabelledText } from "../../styled/SmallLabelledText"
import { toTitleCase } from "../../../utils/utilityFunctions"

/**
 * 
 * @param {object} props {
 * notes [{status, memoType, dateLogged, note}, ...]
 * }
 */
export function DlspStatusHistory({statusHistory}) {

    console.log('DlspStatusHistory RENDER')
    if (!statusHistory || !statusHistory.length) {
        console.log('DlspStatusHistory return null')
        return null
    }
    return (
        <Box sx={{mb:4}}>
            <Typography sx={{pb: 1}} variant="body2">Changes to ICP Registry Status</Typography>
            {
            statusHistory.map((s) => {

                const formattedDate = format(parseISO(s.startDate), 'd MMMM yyyy')
                const theLabel = `${formattedDate}`
                const theText = `${toTitleCase(s.status)}. ${s.reason || ''}`
                return (
                    <SmallLabelledText key={theLabel} label={theLabel} text={theText} />
                )
            })
            }
            {/* <DebugBox title="statusHistory" stringify>{statusHistory}</DebugBox> */}
        </Box>
    )
}

